module.exports = __webpack_public_path__ + "img/1440.3cc9b571.jpg";